import { useMemo } from "react";

import { OrderItemModel } from "@/redux/modules/api/data/orderDetail/@types/orderItem.model";
import { getProductConfigurationPreview } from "@/utils/productConfiguration";
import { getProductConfiguration } from "@/utils/productConfiguration/productConfiguration.utils";

type HeaderComponentProps = {
    item: OrderItemModel;
    link?: boolean;
};

const getConfiguration = (item: OrderItemModel) => {
    const productConfiguration = getProductConfiguration({ sku: item.sku });

    return getProductConfigurationPreview(
        item.configuration,
        productConfiguration
    );
};

const HeaderComponent = ({ item, link }: HeaderComponentProps) => {
    const productConfiguration = useMemo(() => getConfiguration(item), [item]);

    const headerTitle = `${item.title} ${productConfiguration}`;

    return item.url && link ? (
        <a
            className={"d-block"}
            href={item.url}
        >
            {headerTitle}
        </a>
    ) : (
        <span className={"h4 font-weight-normal m-0 pb-2 d-block"}>
            {headerTitle}
        </span>
    );
};

export { HeaderComponent };
